import { tableItem } from './BenefitsTable';
import {
    SavingIcon1,
    SavingIcon2,
    SavingIcon3,
    SavingIcon4,
    SavingIcon5,
    SavingIcon6,
    SavingIcon7,
    SavingIcon8,
    SavingIcon9,
    SavingIcon10,
    SavingIcon11,
    SupportIcon1,
    SupportIcon2,
    SupportIcon3,
    SupportIcon4,
    SupportIcon5,
    SupportIcon6,
    ExpIcon1,
    ExpIcon2,
    ExpIcon3,
    ExpIcon4,
} from '@/components/EcoCredits/Svg';

export type IActive = 'savings' | 'support' | 'experiences';

export const useTableList = (active: IActive, locale: string, t: any): tableItem[] => {
    // more savings
    if (active === 'savings') {
        const arr = [
            {
                icon: SavingIcon1,
                text: t('ecoflowbenefits_savings1'),
            },
            {
                icon: SavingIcon2,
                text: t('ecoflowbenefits_savings2'),
            },
            {
                icon: SavingIcon3,
                text: t('ecoflowbenefits_savings3'),
            },
            {
                icon: SavingIcon4,
                text: t('ecoflowbenefits_savings4'),
            },
            {
                icon: SavingIcon7,
                text: t('ecoflowbenefits_savings7'),
                linkText: t('ecoflowbenefits_savings7_link'),
                key: 'referral',
            },
            {
                icon: SavingIcon8,
                text: t('ecoflowbenefits_savings8'),
            },
            {
                icon: SavingIcon9,
                text: t('ecoflowbenefits_savings9'),
                onlyPlus: true,
            },
            {
                icon: SavingIcon10,
                text: t('ecoflowbenefits_savings10'),
                onlyPlus: true,
                tips: locale === 'ca' ? '*Remark: Only for PLUS MEMBERS with accumulated purchasses over $10000 and only once for the entire program.' : '',
            },
            {
                icon: SavingIcon11,
                text: t('ecoflowbenefits_savings11'),
                onlyPlus: true,
            },
        ];
        if (locale === 'us') {
            return [
                {
                    icon: SavingIcon1,
                    text: t('ecoflowbenefits_savings1'),
                },
                {
                    icon: SavingIcon2,
                    text: t('ecoflowbenefits_savings2'),
                },
                {
                    icon: SavingIcon3,
                    text: t('ecoflowbenefits_savings3'),
                },
                {
                    icon: SavingIcon4,
                    text: t('ecoflowbenefits_savings4'),
                },
                {
                    icon: SavingIcon5,
                    text: t('ecoflowbenefits_savings5'),
                    linkText: t('ecoflowbenefits_savings5_link'),
                    key: 'getCode1',
                },
                {
                    icon: SavingIcon6,
                    text: t('ecoflowbenefits_savings6'),
                    linkText: t('ecoflowbenefits_savings6_link'),
                    key: 'getCode2',
                },
                {
                    icon: SavingIcon7,
                    text: t('ecoflowbenefits_savings7'),
                    linkText: t('ecoflowbenefits_savings7_link'),
                    key: 'referral',
                },
                {
                    icon: SavingIcon8,
                    text: t('ecoflowbenefits_savings8'),
                },
                {
                    icon: SavingIcon9,
                    text: t('ecoflowbenefits_savings9'),
                    onlyPlus: true,
                },
                {
                    icon: SavingIcon10,
                    text: t('ecoflowbenefits_savings10'),
                    onlyPlus: true,
                    tips: '*Remark: Only for PLUS MEMBERS with accumulated purchasses over $10000 and only once for the entire program.',
                },
                {
                    icon: SavingIcon11,
                    text: t('ecoflowbenefits_savings11'),
                    onlyPlus: true,
                },
            ];
        }
        if (locale === 'jp') {
            return [
                {
                    icon: SavingIcon1,
                    text: t('ecoflowbenefits_savings1'),
                },
                {
                    icon: SavingIcon2,
                    text: t('ecoflowbenefits_savings2'),
                },
                {
                    icon: SavingIcon3,
                    text: t('ecoflowbenefits_savings3'),
                },
                {
                    icon: SavingIcon7,
                    text: t('ecoflowbenefits_savings7'),
                    linkText: t('ecoflowbenefits_savings7_link'),
                    key: 'referral',
                },
                {
                    icon: SavingIcon8,
                    text: t('ecoflowbenefits_savings8'),
                    onlyPlus: true,
                },
                {
                    icon: SavingIcon9,
                    text: t('ecoflowbenefits_savings9'),
                    onlyPlus: true,
                },
                {
                    icon: SavingIcon10,
                    text: t('ecoflowbenefits_savings12'),
                    tips: t('ecoflowbenefits_savings_tips4'),
                    onlyPlus: true,
                },
            ];
        }
        if (['au', 'za', 'br', 'mx'].includes(locale)) {
            arr.pop();
        }
        return arr;
    }
    // more support
    if (active === 'support') {
        const arr = [
            {
                icon: SupportIcon1,
                text: t('ecoflowbenefits_support1'),
            },
            {
                icon: SupportIcon2,
                text: t('ecoflowbenefits_support2'),
            },
            {
                icon: SupportIcon3,
                text: t('ecoflowbenefits_support3'),
                tips: t('ecoflowbenefits_savings_tips1'),
                onlyPlus: true,
            },
            {
                icon: SupportIcon4,
                text: t('ecoflowbenefits_support4'),
                tips: t('ecoflowbenefits_savings_tips2'),
                onlyPlus: true,
            },
            {
                icon: SupportIcon5,
                text: t('ecoflowbenefits_support5'),
                tips: t('ecoflowbenefits_savings_tips3'),
                onlyPlus: true,
            },
            {
                icon: SupportIcon6,
                text: t('ecoflowbenefits_support6'),
                tips: t('ecoflowbenefits_savings_tips4'),
                onlyPlus: true,
            },
        ];
        // na去掉最后一项
        if (['us', 'ca'].includes(locale)) {
            arr.pop();
        }
        if (locale === 'jp') {
            return [
                {
                    icon: SupportIcon1,
                    text: t('ecoflowbenefits_support1'),
                },
                {
                    icon: SupportIcon3,
                    text: t('ecoflowbenefits_support3'),
                    tips: t('ecoflowbenefits_savings_tips1'),
                    onlyPlus: true,
                },
                {
                    icon: SupportIcon4,
                    text: t('ecoflowbenefits_support4'),
                    tips: t('ecoflowbenefits_savings_tips2'),
                    onlyPlus: true,
                },
            ];
        }
        return arr;
    }
    // more experiences
    if (active === 'experiences') {
        const arr = [
            {
                icon: ExpIcon1,
                text: t('ecoflowbenefits_experiences1'),
            },
            {
                icon: ExpIcon2,
                text: t('ecoflowbenefits_experiences2'),
            },
            {
                icon: ExpIcon3,
                text: t('ecoflowbenefits_experiences3'),
                onlyPlus: true,
            },
            {
                icon: ExpIcon4,
                text: t('ecoflowbenefits_experiences4'),
                onlyPlus: true,
            },
        ];
        if (locale === 'jp') {
            return [
                {
                    icon: ExpIcon1,
                    text: t('ecoflowbenefits_experiences3'),
                    onlyPlus: true,
                },
            ];
        }
        if (['uk', 'eu', 'it', 'fr', 'es', 'de'].includes(locale)) {
            arr.pop();
        }
        if (['kr'].includes(locale)) {
            arr.shift();
        }
        return arr;
    }
    return [];
};
